<template>
  <div class="custom-modal" v-if="visible">
    <div class="custom-modal-content">
      <div class="custom-modal-header">
        <span>{{ title }}</span>
        <button @click="close" class="close-btn">×</button>
      </div>
      <div class="custom-modal-body">
        <p>{{ message }}</p>
      </div>
      <div class="custom-modal-footer">
        <button @click="confirm" class="confirm-btn">OK</button>
        <button @click="cancel" class="cancel-btn">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, nextTick } from 'vue';

const props = defineProps({
  title: String,
  message: String,
  visible: Boolean,
});

const emit = defineEmits(['confirm', 'cancel']);

function close() {}

function confirm() {
  close();
  emit('confirm');
}

import { onMounted, watch } from 'vue';

function cancel() {
  close();
  emit('cancel');
}

onMounted(() => {
  watch(
    () => props.visible,
    (newVal) => {
      if (newVal) {
        nextTick(() => {
          document.querySelector('.confirm-btn').focus();
        });
      }
    },
  );
});
</script>

<style scoped>
/* Add your styling here */
.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.custom-modal-header {
  background: #333;
  color: #fff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin: -20px;
  padding: 10px;
  margin-bottom: 10px;
  height: 16px;
}

.custom-modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 225px;
  box-shadow: 9px 8px 7px rgba(0, 0, 0, 0.1);
  border: 1px solid #676363;
}

.close-btn {
  float: right;
  cursor: pointer;
}
.confirm-btn,
.cancel-btn {
  margin-top: 5px;
  width: 60px;
  border-radius: 4px;
  border: 1px solid #aaa;
  height: 24px;
  margin-right: 5px;
  background: #a080a8;
  color: #fff;
}
</style>
